import React from 'react';
import cn from 'clsx';
import css from 'styled-jsx/css';
import ButtonBecomeCreator from '../ButtonBecomeCreator';
import IconUser from '~/components/svg/icon-user.svg';
import IconVerify from '~/components/svg/icon-verify.svg';
import IconCamera from '~/components/svg/icon-camera.svg';
import IconCreditCard from '~/components/svg/icon-creditcard.svg';
import Step1 from '~/../static/assets/landing-page-photo-ac/photoac-landing-page-step01.svg';
import Step2 from '~/../static/assets/landing-page-photo-ac/photoac-landing-page-step02.svg';
import Step3 from '~/../static/assets/landing-page-photo-ac/photoac-landing-page-step03.svg';
import Step4 from '~/../static/assets/landing-page-photo-ac/photoac-landing-page-step04.svg';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';

const steps = [
  {
    number: 1,
    labelKey: 'sign_up',
    Icon: IconUser,
    Step: Step1,
  },
  {
    number: 2,
    labelKey: 'verify_identity',
    Icon: IconVerify,
    Step: Step2,
  },
  {
    number: 3,
    labelKey: 'start_uploading',
    Icon: IconCamera,
    Step: Step3,
  },
  {
    number: 4,
    labelKey: 'earn_money',
    Icon: IconCreditCard,
    Step: Step4,
  },
];

const Steps = ({ t, style }) => {
  return (
    <>
      <div className="steps">
        <div className="container-step">
          <h3 className="heading-steps">
            {t('photoac_landing_page_heading_step')}
          </h3>
          <div className="steps-list">
            {steps.map(({ number, labelKey, Icon, Step }) => (
              <div
                key={number}
                className={cn('step-item', `step ${config.serviceType}`)}
              >
                <div className="step-content">
                  <div className="step-header">
                    <div className="step-number">
                      <span className="number">{number}</span>
                    </div>
                    <Step className="icon-number" />
                  </div>
                  <div className="step-body">
                    <span className="label">{t(labelKey)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="benefit">
            <div className="benefit-container">
              {config.isPhotoAC() ? (
                <img
                  className="img-benefit-ipad lazyload"
                  data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_benefit_ipad.png`}
                />
              ) : (
                <img
                  className="img-benefit-ipad illustac lazyload"
                  data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_benefit_ipad.png`}
                />
              )}

              <div className={`overlay ${config.serviceType}`}>
                <h3 className="heading-benefit">
                  {t('photoac_landing_page_heading_benefit')}
                </h3>
                <ul className="content-benefit">
                  <li>{t('photoac_landing_page_content01_benefit')}</li>
                  <li>{t('photoac_landing_page_content02_benefit')}</li>
                  <li>{t('photoac_landing_page_content03_benefit')}</li>
                  <li>{t('photoac_landing_page_content04_benefit')}</li>
                </ul>
                <div className="button-benefit">
                  <ButtonBecomeCreator
                    t={t}
                    style={{ marginTop: themeVariables.space.base }}
                    display="full-width"
                  />
                </div>
              </div>
              {config.isPhotoAC() ? (
                <img
                  className="img-benefit-desktop lazyload"
                  data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_benefit.png`}
                />
              ) : (
                <img
                  className="img-benefit-desktop lazyload"
                  data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_benefit.png`}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="background-split"></div>
      <style jsx>{styles}</style>
    </>
  );
};

const styles = css`
  .steps {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 100px;
    margin-bottom: -80px;
    background: #f8f9fa;
    // background: grey;
  }
  .heading-steps{
    font-weight: 600;
    font-size: 40px;
  }
  .container-step {
    width: 100%;
    max-width: 1248px;
    display: flex;
    flex-direction: column;
    margin-top: 5%;
    // background: red;
  }
  .heading-benefit {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 47px;
    letter-spacing: -0.03em;

    /* MILKY */

    color: #ffffff;
    margin: 24px 0px;
  }
  .content-benefit {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */

    /* MILKY */

    color: #ffffff;
  }
  .content-benefit li {
    margin: 8px 0;
  }
  .steps-list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: ${themeVariables.space.base}px;
    width: 100%;
    max-width: 1248px;
  }

  .step-item {
    position: relative;
    width: 23%;
    height: 140px;
    border-radius: 4px;
    // margin: 0 ${themeVariables.space.half}px;
    box-shadow: 4px 4px 4px rgba(27, 40, 51, 0.25);
    border-radius: 4px;
  }

  .step-content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .step-header {
    position: relative;
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 0 ${themeVariables.space.half}px;
    margin-top: ${themeVariables.space.small}px;
  }

  .step-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${themeVariables.space.small}px;
  }

  .step {
    background: #1b2833;
  }
  .step.illust_ac{
    background: #454285;;
  }

  .step-number {
    position: absolute;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .number {
    font-size: ${themeVariables.fontSize.extraLarge}px;
    font-weight: bold;
    color: #fff;
    position: absolute;
    left: ${themeVariables.space.half}px;
  }

  .label {
    margin-top: ${themeVariables.space.base}px;

    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: -0.03em;

    /* MILKY */

    color: #ffffff;
  }
  .benefit {
    margin-top: 10%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .benefit-container {
    width: 100%;
    max-width: 1248px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .overlay {
    position: absolute;
    // background: rgba(47, 59, 51, 0.5);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;

    z-index: 800;
    padding: 0;
    margin-top: 7%;
    width: 48%;
  }
  .overlay.photo_ac{
    top:10%;
  }
  .img-benefit-desktop {
    position: relative;
    width: inherit;
  }
  .img-benefit-ipad{
    display:none;
  }
  .background-split {
    width: 100%;
    height: 200px;
    background: white;
  }
  @media screen and (min-width: 905px) and (max-width: 1239px) {
    .overlay {
    }
    .heading-benefit {
      font-size: 24px;
      margin-top: 12px;
      margin-bottom: 4px;
      line-height: 27px;
    }
    .heading-steps{
      font-weight: 600;
      font-size: 24px;
    }

    .steps{
      padding-left:  32px;
      padding-right:  32px;

    }
  }
  @media screen and (min-width: 730px) and (max-width: 904px) {
    .steps{
      padding: 0 16px;
    }
    .steps-list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 2rem;
    }

    .step-item {
      width: 100%;
      height: 84px;
      padding-top: 0%;
    }

    .step-header {
      height: 36px;
    }

    .step-number {
      position: absolute;
      left: -${themeVariables.space.small}px;
      font-size:24px;
    }

    .icon-number {
      width: 22px;
      height: 22px;
    }

    .number {
      font-size: ${themeVariables.fontSize.large}px;
    }

    .icon-step {
      width: ${themeVariables.space.large}px;
      height: ${themeVariables.space.large}px;
    }

    .label {
      font-size: ${themeVariables.fontSize.base}px;
      margin-top: 0px;
    }
    .background-split {
      height:0px;
    }
    .img-benefit-desktop {
      display:none;
    }
    .benefit-container{
      display:block;
    }
    .img-benefit-ipad {
      display:block;
      position: relative;
      width: 100%;
      z-index:1;
    }
    .img-benefit-ipad.illustac{
    }
    .overlay {
      position: relative;
      width: 100%;
      bottom: 0;
      right: 0;
      top: 0;
      background: #1B2833;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      color: #fff;
      padding: ${themeVariables.space.half}px;
      padding-left: 20px;
      padding-bottom: 2%;
      z-index: 800;
      margin-top:-4%;
      z-index:0;

    }
    .heading-benefit {
      font-size: 24px;
      margin: 24px 0px;
      line-height: 27px;
    }
    .content-benefit{
      padding: 0 20px;
    }
    .button-benefit{
      display: flex;
      justify-content: center;
      width: 100%;
    }
`;

export default Steps;
